import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Http, HttpModule } from '@angular/http';

import { ICacheRepository, SessionStorage } from '@bhtp-client-api/base';
import { BhtpEligibilityModule } from '@bhtp-client-api/eligibility';
import { BhtpComponentModule } from '@bhtp-client-web/component';

import {
    AgentQuoteSidebarComponent, PaymentIFrameComponent, CoverageDisplayListComponent, CoverageDisplayComponent, CoverageDrawerComponent,
    ReceiptComponent, AlertBoxComponent, CreditAgentPanelComponent, TypeaheadAgentNameSearchComponent, TypeaheadAgentCodeSearchComponent
} from './components';

import { ValidateOnBlurDirective } from './directives/validate-onblur.directive';

import { CustomerService, PaymentService, PrintService, FeatureService, TramsService, AgentNameTypeaheadService, AgentCodeTypeaheadService, AmbassadorInformationSessionStorage } from './services';
import { SaveQuoteService } from '../quotes/save-quote.service';
import { EmailQuoteService } from '../email-quote/email-quote.service';
import { InsuredEventMapperV2 } from './helpers/insured-event.mapper-v2';
import { QuoteHelper } from './helpers/quote.helper';
import { CoverageService } from '../coverage-modal/coverage.service';
import { PolicyDocumentService } from '../policy/policy-document.service';

export function bhtpCustomerServiceFactory(http: Http): CustomerService {
    return new CustomerService(http);
}

export const DECLARED_AND_EXPORTED_COMPONENTS: any[] = [
    ValidateOnBlurDirective,
    PaymentIFrameComponent,
    CoverageDisplayComponent,
    CoverageDisplayListComponent,
    CoverageDrawerComponent,
    ReceiptComponent,
    AlertBoxComponent,
    CreditAgentPanelComponent,
    TypeaheadAgentNameSearchComponent,
    TypeaheadAgentCodeSearchComponent,
    AgentQuoteSidebarComponent
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        BhtpComponentModule.forRoot(),
        BhtpEligibilityModule
    ],
    providers: [
        PaymentService,
        { provide: CustomerService, useFactory: bhtpCustomerServiceFactory, deps: [Http] },
        PrintService,
        { provide: 'ICacheRepository', useClass: SessionStorage },
        FeatureService,
        TramsService,
        AgentNameTypeaheadService,
        AgentCodeTypeaheadService,
        AmbassadorInformationSessionStorage,
        SaveQuoteService,
        EmailQuoteService,
        InsuredEventMapperV2,
        QuoteHelper,
        CoverageService,
        PolicyDocumentService
    ],
    declarations: [
        DECLARED_AND_EXPORTED_COMPONENTS
    ],
    exports: [
        DECLARED_AND_EXPORTED_COMPONENTS
    ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/shared.module.ts